"use client";
import { resolveClassNames } from "../resolve-class-names/resolve-class-names.mjs";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-options-class-names/get-options-class-names.ts
function getOptionsClassNames({ selector, stylesCtx, options, props, theme }) {
	return resolveClassNames({
		theme,
		classNames: options?.classNames,
		props: options?.props || props,
		stylesCtx
	})[selector];
}
//#endregion
export { getOptionsClassNames };

//# sourceMappingURL=get-options-class-names.mjs.map